<div class="flex justify-between items-center px-4 py-2.5 bg-white relative">
  <ra-title></ra-title>
  <button
    (click)="toggleMenu()"
    class="p-2 border-0 bg-gray-100 rounded-lg justify-center items-center gap-2 inline-flex"
  >
    <ng-container [ngSwitch]="menuToggle">
      <ng-template [ngSwitchCase]="true">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.75 5.25L5.25 18.75"
            stroke="#050A24"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.75 18.75L5.25 5.25"
            stroke="#050A24"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </ng-template>
      <ng-template [ngSwitchCase]="false">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.75 12H20.25"
            stroke="#050A24"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.75 6H20.25"
            stroke="#050A24"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.75 18H20.25"
            stroke="#050A24"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </ng-template>
    </ng-container>
  </button>
  <ng-template #MobileSpace></ng-template>
</div>

<div class="p-4 bg-[rgba(255,255,255,1)] rounded-2xl">
  <ra-category [amountCol]="1"></ra-category>
</div>
